import { Component } from "@angular/core";
import {
  NavController,
  AlertController,
  LoadingController,
} from "ionic-angular";
import { AngularFire } from "angularfire2";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { Post } from "../post/post";
import { Matcher } from "../../utils/matcher";
import { inRange, orderBy, take } from "lodash";
import moment from "moment";
import { PostService } from "../../providers/post";

@Component({
  selector: "page-posts",
  templateUrl: "posts.html",
})
export class Posts {
  // Loader
  loader: any = null;

  // regex
  pattern = new Matcher();

  // Data
  isLoaded: boolean = false;
  publicPosts: any;
  privatePosts: any;
  reportedPosts: any;
  searchResults: Observable<any[]>;
  emotions: any = [];
  segmentModel: string = "Public";
  postList: string = "posts";

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public af: AngularFire,
  ) {}

  ionViewWillEnter() {
    this.publicPosts = {
      list: this.af.database.list("/posts", {
        query: {
          orderByChild: "type",
          equalTo: "post",
        },
      }),
      subscription: null,
    };
    this.publicPosts.subscription = this.publicPosts.list.subscribe(data => {
      this.isLoaded = true;
      this.af.database.list(`/emotions`).subscribe(data => {
        this.emotions = data;
        this.getPosts({ target: { value: "*" } });
      });
    });

    this.privatePosts = {
      list: this.af.database.list("/private"),
      subscription: null,
    };
    this.privatePosts.subscription = this.privatePosts.list.subscribe();

    this.reportedPosts = {
      list: this.af.database.list("/reported"),
      subscription: null,
    };
    this.reportedPosts.subscription = this.reportedPosts.list.subscribe();
  }

  ionViewWillLeave() {
    this.publicPosts.subscription.unsubscribe();
    this.publicPosts.subscription = null;

    this.privatePosts.subscription.unsubscribe();
    this.privatePosts.subscription = null;

    this.reportedPosts.subscription.unsubscribe();
    this.reportedPosts.subscription = null;

    this.searchResults = null;
  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      dismissOnPageChange: true,
    });
    this.loader.present();
  }

  checkTimestamp(ts: number, fromDate: number, toDate?: number) {
    if (!fromDate) {
      return true;
    }

    if (toDate) {
      return inRange(ts, fromDate, toDate);
    } else {
      return inRange(ts, fromDate, moment().unix());
    }
  }

  getPosts(event: any) {
    let val = event.target.value;
    let query: any = this.pattern.match(
      "<value> <from> <to> <order> <limit>",
      "string date date order number",
      val,
    );
    if (!query.value || query.value === "*") {
      query.value = "";
    } else {
      query.value = query.value.toLowerCase();
    }

    let tmpObs: any = null;
    if (this.segmentModel === "Private") {
      this.postList = "private";
      tmpObs = this.privatePosts.list;
    } else if (this.segmentModel === "Reported") {
      this.postList = "reported";
      tmpObs = this.reportedPosts.list;
    } else {
      this.postList = "posts";
      tmpObs = this.publicPosts.list;
    }

    this.searchResults = tmpObs.map(data => {
      let results = [];
      data.map(item => {
        if (
          JSON.stringify(item)
            .toLowerCase()
            .includes(query.value) &&
          this.checkTimestamp(item.timestamp, query.from, query.to)
        ) {
          this.emotions.map(emotion => {
            if (emotion.title_en.toLowerCase().includes(item.emotion)) {
              item.color = emotion.color;
            }
          });
          results.push(item);
        }
      });
      results = take(
        orderBy(results, ["timestamp"], [query.order || "desc"]),
        query.limit || results.length,
      );
      tmpObs = null;
      return results;
    });
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  showPromptConfirmation(postModel: any) {
    let prompt = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: "Are you sure?",
      buttons: [
        {
          text: "Yes",
          handler: data => {
            try {
              this.presentLoading();
              this.af.database.object(`posts/${postModel.$key}`).remove();
              setTimeout(() => {
                this.dismissLoader();
              }, 1000);
            } catch (err) {
              console.log("showPromptConfirmation - error", err);
            }
          },
        },
        {
          text: "No",
        },
      ],
    });
    prompt.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  onChangeType(event: any) {
    setTimeout(() => {
      this.getPosts({ target: { value: event } });
    });
  }

  onPost(postModel: any) {
    this.navCtrl.push(Post, {
      postModel: postModel,
      postList: this.postList,
    });
  }

  onLogout() {
    return this.af.auth.logout();
  }

  onBlock(postModel: any, blocked: string) {
    try {
      this.af.database
        .object(`posts/${postModel.$key}`)
        .update({ blocked: blocked });

      this.af.database
        .object(`private/${postModel.$key}`)
        .take(1)
        .subscribe(data => {
          if (data.$exists()) {
            this.af.database
              .object(`private/${postModel.$key}`)
              .update({ blocked: blocked });
          }
        });

      this.af.database
        .object(`reported/${postModel.$key}`)
        .take(1)
        .subscribe(data => {
          if (data.$exists()) {
            this.af.database
              .object(`reported/${postModel.$key}`)
              .update({ blocked: blocked });
          }
        });
    } catch (error) {
      console.log("onBlock", error);
    }
  }

  onDelete(postModel: any) {
    this.showPromptConfirmation(postModel);
  }

  getModerated(value) {
    return value === PostService.postModerateStateModerated
      ? "\u2714"
      : "\u2718";
  }

  getBlocked(value) {
    return value === PostService.postBlockStateBlocked ? "\u2714" : "\u2718";
  }
}



// WEBPACK FOOTER //
// ./src/pages/posts/posts.ts